import create from './create';
import detail from './detail';
import edit from './edit';
import events from './events';
import list from './list';

const ApiCall = {
  list,
  detail,
  create,
  edit,
  events,
};

export default ApiCall;
